import React, { Component, lazy, Suspense } from 'react';
import { createHashHistory } from 'history';
import { Routes, Route, Switch, Redirect } from "react-router-dom";
import LoadingOverlay from 'react-loading-overlay';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';


const MfaPage = lazy(() => import('../Utility/Components/MfaPage'));

LoadingOverlay.propTypes = undefined;
class index extends Component {

    render() {
        return (
            <>
                <Suspense fallback={<Loading />}>
                    <Switch>
                        <Route exact path="/:lng/mfa" component={MfaPage} />
                    </Switch >
                </Suspense >
            </>


        );
    }
}

const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials,
        accessToken: globalState.LoginReducer.accessToken,
        token: globalState.LoginReducer.token,
        leftbar: globalState.mainReducerData.leftbar,
    };
}

export default connect(mapStateToProps)(withRouter(index));

function Loading() {
    return (
        <>
            <div className="wrapperContainer">
                <span>Loading</span>
            </div>
        </>
    );
}
